// Route constants only (react-router v6 handles params via hooks in components)
export const ROUTE_LOGIN = '/login';
export const ROUTE_SIGNUP = '/register';
export const ROUTE_FORGOT = '/forgot';
export const ROUTE_SET_PASSWORD = '/set-password';

export const ROUTE_DISCOVER = '/discover';
export const ROUTE_DISCOVER_QUESTIONNAIRE = '/discover/questionnaire';
export const ROUTE_DISCOVER_RESULT = '/discover/result';
export const ROUTE_DISCOVER_RESULT_PDF = '/discover/result/pdf';

export const ROUTE_ANALYSE = '/analyse';
export const ROUTE_ANALYSE_OVERVIEW = '/analyse/overview';
export const ROUTE_ANALYSE_SELECT = '/analyse/select';
export const ROUTE_ANALYSE_INFO = '/analyse/info';
export const ROUTE_ANALYSE_VIDEO = '/analyse/video';

export const ROUTE_TIPS = '/tips';
export const ROUTE_USERS = '/users';
export const ROUTE_PROFILE = '/profile';

// analyse routing is defined in AnalyseApp.
